
import { useState, useCallback } from "react";
import { Movie, PendingAction } from "@/types/movie";
import { logState } from "@/utils/debugLogger";

/**
 * Hook for managing pending actions with simplified approach
 * UPDATED: Removed cleanup interval - auto-commit timeout handles everything
 */
export const usePendingActions = (
  updateMovieState: (tmdbId: number, props: Partial<Movie>) => void
) => {
  const [pendingActions, setPendingActions] = useState<PendingAction[]>([]);

  // Add a pending action
  const addPendingAction = useCallback((action: PendingAction) => {
    logState("Adding pending action", {
      id: action.id,
      movieId: action.movieId,
      fromSection: action.fromSection,
      movie: action.movieData?.title || 'unknown'
    });
    setPendingActions(prev => [...prev, action]);
  }, []);
  
  // Remove a pending action - this handles user-initiated cancellations
  const removePendingAction = useCallback((actionId: string) => {
    logState("Removing pending action", { actionId });
    setPendingActions(prev => {
      const actionToRemove = prev.find(action => action.id === actionId);
      // Clear timeout and mark as cancelled for user-initiated cancellations (undo button clicks)
      if (actionToRemove?.timeoutId) {
        window.clearTimeout(actionToRemove.timeoutId);
        // Mark the action as cancelled to prevent auto-commit
        actionToRemove.cancelled = true;
      }
      return prev.filter(action => action.id !== actionId);
    });
  }, []);

  return {
    pendingActions,
    addPendingAction,
    removePendingAction
  };
};
